import * as Types from './types-api.generated';


import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiUserMicroFragment = { profileImageUrl: string | null, username: string | null, publicKey: Address };

export type ApiUserLightFragment_User_ = { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address };

export type ApiUserLightFragment_UserLight_ = { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address };

export type ApiUserLightFragment_WorldTeamUser_ = { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address };

export type ApiUserLightFragment = ApiUserLightFragment_User_ | ApiUserLightFragment_UserLight_ | ApiUserLightFragment_WorldTeamUser_;

export type ApiBidFragment = { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } };

export type ApiDropSaleConfigurationFragment_FixedPriceSaleConfiguration_ = { __typename: 'FixedPriceSaleConfiguration', maxTokenId: number, mintPrice: number, presaleStartTime: string | null, startTime: string, fndFixedPriceSaleStatus: Types.ApiFixedPriceStatus };

export type ApiDropSaleConfigurationFragment_HighlightFixedPriceSaleConfiguration_ = { __typename: 'HighlightFixedPriceSaleConfiguration', highlightId: string, mintPrice: number, startTime: string, optionalEndTime: string | null, optionalMaxTokenId: number | null, vectorId: number, highlightFixedPriceSaleStatus: Types.ApiHighlightFixedPriceStatus };

export type ApiDropSaleConfigurationFragment_HighlightLinearDutchAuctionSaleConfiguration_ = { __typename: 'HighlightLinearDutchAuctionSaleConfiguration' };

export type ApiDropSaleConfigurationFragment_HighlightStaggeredDutchAuctionSaleConfiguration_ = { __typename: 'HighlightStaggeredDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, highlightId: string, mintVectorId: string, maxPrice: number, maxTokenId: number, minPrice: number, mintEndTime: string | null, startTime: string, highlightStaggeredDutchAuctionStatus: Types.ApiHighlightDutchAuctionStatus, prices: Array<{ endTime: string, price: number }> };

export type ApiDropSaleConfigurationFragment_LinearDutchAuctionSaleConfiguration_ = { __typename: 'LinearDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, maxPrice: number, maxTokenId: number, minPrice: number, startTime: string, fndLinearDutchAuctionStatus: Types.ApiDutchAuctionStatus };

export type ApiDropSaleConfigurationFragment = ApiDropSaleConfigurationFragment_FixedPriceSaleConfiguration_ | ApiDropSaleConfigurationFragment_HighlightFixedPriceSaleConfiguration_ | ApiDropSaleConfigurationFragment_HighlightLinearDutchAuctionSaleConfiguration_ | ApiDropSaleConfigurationFragment_HighlightStaggeredDutchAuctionSaleConfiguration_ | ApiDropSaleConfigurationFragment_LinearDutchAuctionSaleConfiguration_;

export type ApiDropFragment = { brandColor: string | null, chainId: ChainId, clearingPrice: number | null, collectionImageUrl: string | null, contractAddress: Address, contractType: Types.ApiContractType, coverImageUrl: string | null, description: string | null, earlyAccessStartTime: string | null, endTime: string | null, generalAvailabilityStartTime: string | null, id: string, isRevealed: boolean | null, lastMintedAt: string | null, minPrice: number | null, mintPrice: number | null, moderationFrom: string | null, moderationStatus: Types.ApiModerationStatus, name: string, nftCount: number, saleType: Types.ApiCollectionSaleType | null, slug: string, symbol: string, worldId: number | null, status: Types.ApiDropAvailabilityStatus, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, saleConfiguration: { __typename: 'FixedPriceSaleConfiguration', maxTokenId: number, mintPrice: number, presaleStartTime: string | null, startTime: string, fndFixedPriceSaleStatus: Types.ApiFixedPriceStatus } | { __typename: 'HighlightFixedPriceSaleConfiguration', highlightId: string, mintPrice: number, startTime: string, optionalEndTime: string | null, optionalMaxTokenId: number | null, vectorId: number, highlightFixedPriceSaleStatus: Types.ApiHighlightFixedPriceStatus } | { __typename: 'HighlightLinearDutchAuctionSaleConfiguration' } | { __typename: 'HighlightStaggeredDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, highlightId: string, mintVectorId: string, maxPrice: number, maxTokenId: number, minPrice: number, mintEndTime: string | null, startTime: string, highlightStaggeredDutchAuctionStatus: Types.ApiHighlightDutchAuctionStatus, prices: Array<{ endTime: string, price: number }> } | { __typename: 'LinearDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, maxPrice: number, maxTokenId: number, minPrice: number, startTime: string, fndLinearDutchAuctionStatus: Types.ApiDutchAuctionStatus } | null };

export type ApiCollectionLightFragment_Collection_ = { name: string, slug: string, chainId: ChainId, collectionImageUrl: string | null, contractAddress: Address, contractType: Types.ApiContractType };

export type ApiCollectionLightFragment_Erc1155Collection_ = { name: string, slug: string, chainId: ChainId, collectionImageUrl: string | null, contractAddress: Address, contractType: Types.ApiContractType };

export type ApiCollectionLightFragment_StandardCollection_ = { name: string, slug: string, chainId: ChainId, collectionImageUrl: string | null, contractAddress: Address, contractType: Types.ApiContractType };

export type ApiCollectionLightFragment = ApiCollectionLightFragment_Collection_ | ApiCollectionLightFragment_Erc1155Collection_ | ApiCollectionLightFragment_StandardCollection_;

export type ApiDropSpotlightFragment = { brandColor: string | null, chainId: ChainId, clearingPrice: number | null, collectionImageUrl: string | null, contractAddress: Address, contractType: Types.ApiContractType, coverImageUrl: string | null, description: string | null, earlyAccessStartTime: string | null, endTime: string | null, generalAvailabilityStartTime: string | null, id: string, isRevealed: boolean | null, lastMintedAt: string | null, minPrice: number | null, mintPrice: number | null, moderationFrom: string | null, moderationStatus: Types.ApiModerationStatus, name: string, nftCount: number, saleType: Types.ApiCollectionSaleType | null, slug: string, symbol: string, worldId: number | null, totalSales: number, status: Types.ApiDropAvailabilityStatus, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, saleConfiguration: { __typename: 'FixedPriceSaleConfiguration', maxTokenId: number, mintPrice: number, presaleStartTime: string | null, startTime: string, fndFixedPriceSaleStatus: Types.ApiFixedPriceStatus } | { __typename: 'HighlightFixedPriceSaleConfiguration', highlightId: string, mintPrice: number, startTime: string, optionalEndTime: string | null, optionalMaxTokenId: number | null, vectorId: number, highlightFixedPriceSaleStatus: Types.ApiHighlightFixedPriceStatus } | { __typename: 'HighlightLinearDutchAuctionSaleConfiguration' } | { __typename: 'HighlightStaggeredDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, highlightId: string, mintVectorId: string, maxPrice: number, maxTokenId: number, minPrice: number, mintEndTime: string | null, startTime: string, highlightStaggeredDutchAuctionStatus: Types.ApiHighlightDutchAuctionStatus, prices: Array<{ endTime: string, price: number }> } | { __typename: 'LinearDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, maxPrice: number, maxTokenId: number, minPrice: number, startTime: string, fndLinearDutchAuctionStatus: Types.ApiDutchAuctionStatus } | null };

export type ApiHomeTabFragment = { items: Array<{ createdAt: string, nftId: string, id: string, position: number, size: Types.ApiNftGroupItemSize }> };

export type ApiMediaFragment_ImageMedia_ = { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType };

export type ApiMediaFragment_ModelMedia_ = { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string };

export type ApiMediaFragment_VideoMedia_ = { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType };

export type ApiMediaFragment = ApiMediaFragment_ImageMedia_ | ApiMediaFragment_ModelMedia_ | ApiMediaFragment_VideoMedia_;

export type ApiNftIdentifiersFragment_Erc1155Token_ = { chainId: ChainId, contractAddress: Address, tokenId: number };

export type ApiNftIdentifiersFragment_InventoryMarketNft_ = { chainId: ChainId, contractAddress: Address, tokenId: number };

export type ApiNftIdentifiersFragment_InventorySoldNft_ = { chainId: ChainId, contractAddress: Address, tokenId: number };

export type ApiNftIdentifiersFragment_MarketNft_ = { chainId: ChainId, contractAddress: Address, tokenId: number };

export type ApiNftIdentifiersFragment_SoldNft_ = { chainId: ChainId, contractAddress: Address, tokenId: number };

export type ApiNftIdentifiersFragment = ApiNftIdentifiersFragment_Erc1155Token_ | ApiNftIdentifiersFragment_InventoryMarketNft_ | ApiNftIdentifiersFragment_InventorySoldNft_ | ApiNftIdentifiersFragment_MarketNft_ | ApiNftIdentifiersFragment_SoldNft_;

export type ApiMarketNftGridFields = { chainId: ChainId, name: string | null, id: string, tokenId: number, contractAddress: Address, saleStartsAt: string | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, activeAuction: { duration: number, id: number, reservePrice: number, state: Types.ApiAuctionState, expiryDate: string | null, highestBid: { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null } | null, activeBuyNow: { amount: number } | null, activeOffer: { amount: number, expiryDate: string } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null };

export type ApiArtworkFragment = { id: string, name: string | null, description: string | null, assetScheme: string | null, assetHost: string | null, assetPath: string | null, assetIPFSPath: string | null, metadataScheme: string | null, metadataHost: string | null, metadataPath: string | null, metadataIPFSPath: string | null, mintTxHash: string | null, auctionStartTxHash: string | null, width: number | null, height: number | null, duration: number | null, mimeType: string | null, tokenId: number | null, status: string, hiddenAt: string | null, deletedAt: string | null, moderationStatus: Types.ApiModerationStatus };

export type ApiArtworkFragmentPrivate = { downloadableUrl: string | null, id: string, name: string | null, description: string | null, assetScheme: string | null, assetHost: string | null, assetPath: string | null, assetIPFSPath: string | null, metadataScheme: string | null, metadataHost: string | null, metadataPath: string | null, metadataIPFSPath: string | null, mintTxHash: string | null, auctionStartTxHash: string | null, width: number | null, height: number | null, duration: number | null, mimeType: string | null, tokenId: number | null, status: string, hiddenAt: string | null, deletedAt: string | null, moderationStatus: Types.ApiModerationStatus };

export type ApiCollectionFragment = { id: string, contractAddress: string, symbol: string, name: string, slug: string | null, description: string | null, collectionImageUrl: string | null, coverImageUrl: string | null, createdAt: string, updatedAt: string };

export type ApiWorldOverviewOnExhibition = { chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } };

export type ApiWorldOverviewFragment = { chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } };

export type ApiWorldFragment = { curatorAddress: Address, description: string | null, moderationFrom: string | null, chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } };

export type ApiMomentSearchItemFragment = { id: number, name: string, posterUrl: string | null, worldId: number, worldImageUrl: string | null, worldName: string, worldSlug: string };

export type ApiMomentFragment = { id: number, name: string, description: string | null, worldId: number, posterUrl: string, startsAt: string, takeRateInBasisPoints: number };

export type ApiMomentOverviewFragment = { id: number, name: string, description: string | null, worldId: number, posterUrl: string, startsAt: string, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, world: { chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } };

export type ApiWorldInventoryDrop = { clearingPrice: number | null, contractAddress: Address, curatorRevenue: number, description: string | null, earlyAccessStartTime: string | null, generalAvailabilityStartTime: string | null, id: string, isFeatured: boolean, mintPrice: number | null, name: string, nftCount: number, saleType: Types.ApiCollectionSaleType | null, slug: string, totalPageViews: number, totalVolumeInEth: number, chainId: ChainId, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, saleConfiguration: { __typename: 'FixedPriceSaleConfiguration', maxTokenId: number, mintPrice: number, presaleStartTime: string | null, startTime: string, fndFixedPriceSaleStatus: Types.ApiFixedPriceStatus } | { __typename: 'HighlightFixedPriceSaleConfiguration', highlightId: string, mintPrice: number, startTime: string, optionalEndTime: string | null, optionalMaxTokenId: number | null, vectorId: number, highlightFixedPriceSaleStatus: Types.ApiHighlightFixedPriceStatus } | { __typename: 'HighlightLinearDutchAuctionSaleConfiguration' } | { __typename: 'HighlightStaggeredDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, highlightId: string, mintVectorId: string, maxPrice: number, maxTokenId: number, minPrice: number, mintEndTime: string | null, startTime: string, highlightStaggeredDutchAuctionStatus: Types.ApiHighlightDutchAuctionStatus, prices: Array<{ endTime: string, price: number }> } | { __typename: 'LinearDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, maxPrice: number, maxTokenId: number, minPrice: number, startTime: string, fndLinearDutchAuctionStatus: Types.ApiDutchAuctionStatus } | null };

export type ApiWorldInventoryEdition = { contractAddress: Address, contractType: Types.ApiContractType, curatorRevenue: number, description: string | null, id: string, isFeatured: boolean, name: string, nftCount: number, slug: string, totalPageViews: number, totalVolumeInEth: number, chainId: ChainId, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, editionSale: { __typename: 'LimitedEditionSaleConfiguration', maxTokenId: number, mintPrice: number, startTime: string, limitedEditionStatus: Types.ApiLimitedEditionStatus } | { __typename: 'TimedEditionSaleConfiguration', endTime: string, mintPrice: number, startTime: string, timedEditionStatus: Types.ApiTimedEditionStatus } };

export type ApiWorldInventoryMarketNft = { chainId: ChainId, contractAddress: Address, id: string, isFeatured: boolean, name: string | null, saleStartsAt: string | null, tokenId: number, totalPageViews: number, activeAuction: { expiryDate: string | null, reservePrice: number, state: Types.ApiAuctionState, highestBid: { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null } | null, activeBuyNow: { amount: number } | null, activeOffer: { amount: number, expiryDate: string } | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null };

export type ApiWorldInsightBreakdownStats = { timestamp: string, totalPageViews: number, totalSales: number };

export type ApiMomentStatsFragment = { collectorsCount: number, liveActivityCount: number, totalSales: number, worksCount: number, isSoldOut: boolean, bookmarksCount: number };

export type ApiEditionSaleConfigurationFragment_LimitedEditionSaleConfiguration_ = { __typename: 'LimitedEditionSaleConfiguration', maxTokenId: number, mintPrice: number, startTime: string, limitedEditionStatus: Types.ApiLimitedEditionStatus };

export type ApiEditionSaleConfigurationFragment_TimedEditionSaleConfiguration_ = { __typename: 'TimedEditionSaleConfiguration', endTime: string, mintPrice: number, startTime: string, timedEditionStatus: Types.ApiTimedEditionStatus };

export type ApiEditionSaleConfigurationFragment = ApiEditionSaleConfigurationFragment_LimitedEditionSaleConfiguration_ | ApiEditionSaleConfigurationFragment_TimedEditionSaleConfiguration_;

export type ApiEditionFragment = { chainId: ChainId, id: string, name: string, slug: string, symbol: string, nftCount: number, description: string | null, contractAddress: Address, assetUrl: string | null, mimeType: string | null, moderationStatus: Types.ApiModerationStatus, moderationFrom: string | null, tokenUri: string, contractType: Types.ApiContractType, worldId: number | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, editionSale: { __typename: 'LimitedEditionSaleConfiguration', maxTokenId: number, mintPrice: number, startTime: string, limitedEditionStatus: Types.ApiLimitedEditionStatus } | { __typename: 'TimedEditionSaleConfiguration', endTime: string, mintPrice: number, startTime: string, timedEditionStatus: Types.ApiTimedEditionStatus } };

export type ApiEditionSpotlightFragment = { chainId: ChainId, id: string, name: string, slug: string, symbol: string, nftCount: number, description: string | null, contractAddress: Address, assetUrl: string | null, mimeType: string | null, moderationStatus: Types.ApiModerationStatus, moderationFrom: string | null, tokenUri: string, contractType: Types.ApiContractType, worldId: number | null, totalSales: number, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, editionSale: { __typename: 'LimitedEditionSaleConfiguration', maxTokenId: number, mintPrice: number, startTime: string, limitedEditionStatus: Types.ApiLimitedEditionStatus } | { __typename: 'TimedEditionSaleConfiguration', endTime: string, mintPrice: number, startTime: string, timedEditionStatus: Types.ApiTimedEditionStatus } };

export type ApiNftSpotlightFragment = { chainId: ChainId, name: string | null, tokenId: number, description: string | null, contractAddress: Address, saleStartsAt: string | null, activeBuyNow: { amount: number } | null, activeOffer: { expiryDate: string, amount: number, publicKey: Address } | null, activeAuction: { id: number, state: Types.ApiAuctionState, expiryDate: string | null, reservePrice: number, duration: number, highestBid: { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null } | null, lastSale: { amount: number, date: string, worldId: number | null, buyer: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, world: { chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null };

export type ApiStoryInventoryItemFragment_DropCollection_ = { __typename: 'DropCollection', chainId: ChainId, contractAddress: Address, slug: string, nftCount: number, dropName: string, dropId: string, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, saleConfiguration: { __typename: 'FixedPriceSaleConfiguration', maxTokenId: number, mintPrice: number, presaleStartTime: string | null, startTime: string, fndFixedPriceSaleStatus: Types.ApiFixedPriceStatus } | { __typename: 'HighlightFixedPriceSaleConfiguration', highlightId: string, mintPrice: number, startTime: string, optionalEndTime: string | null, optionalMaxTokenId: number | null, vectorId: number, highlightFixedPriceSaleStatus: Types.ApiHighlightFixedPriceStatus } | { __typename: 'HighlightLinearDutchAuctionSaleConfiguration' } | { __typename: 'HighlightStaggeredDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, highlightId: string, mintVectorId: string, maxPrice: number, maxTokenId: number, minPrice: number, mintEndTime: string | null, startTime: string, highlightStaggeredDutchAuctionStatus: Types.ApiHighlightDutchAuctionStatus, prices: Array<{ endTime: string, price: number }> } | { __typename: 'LinearDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, maxPrice: number, maxTokenId: number, minPrice: number, startTime: string, fndLinearDutchAuctionStatus: Types.ApiDutchAuctionStatus } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null };

export type ApiStoryInventoryItemFragment_EditionCollection_ = { __typename: 'EditionCollection', chainId: ChainId, contractAddress: Address, nftCount: number, slug: string, contractType: Types.ApiContractType, assetUrl: string | null, mimeType: string | null, editionName: string, editionId: string, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, editionSale: { __typename: 'LimitedEditionSaleConfiguration', maxTokenId: number, mintPrice: number, startTime: string, limitedEditionStatus: Types.ApiLimitedEditionStatus } | { __typename: 'TimedEditionSaleConfiguration', endTime: string, mintPrice: number, startTime: string, timedEditionStatus: Types.ApiTimedEditionStatus } };

export type ApiStoryInventoryItemFragment_MarketNft_ = { __typename: 'MarketNft', chainId: ChainId, name: string | null, id: string, tokenId: number, contractAddress: Address, saleStartsAt: string | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, activeAuction: { duration: number, id: number, reservePrice: number, state: Types.ApiAuctionState, expiryDate: string | null, highestBid: { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null } | null, activeBuyNow: { amount: number } | null, activeOffer: { amount: number, expiryDate: string } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null };

export type ApiStoryInventoryItemFragment_SoldNft_ = { __typename: 'SoldNft', chainId: ChainId, contractAddress: Address, tokenId: number, soldNftId: string, soldNftName: string | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, sale: { amount: number, date: string } };

export type ApiStoryInventoryItemFragment = ApiStoryInventoryItemFragment_DropCollection_ | ApiStoryInventoryItemFragment_EditionCollection_ | ApiStoryInventoryItemFragment_MarketNft_ | ApiStoryInventoryItemFragment_SoldNft_;

export type ApiStoryItemFragment = { id: string, type: Types.ApiStoryGroupItemType, contentV2: { __typename: 'StoryItemInventoryContent', referenceId: string, item: { __typename: 'DropCollection', chainId: ChainId, contractAddress: Address, slug: string, nftCount: number, dropName: string, dropId: string, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, saleConfiguration: { __typename: 'FixedPriceSaleConfiguration', maxTokenId: number, mintPrice: number, presaleStartTime: string | null, startTime: string, fndFixedPriceSaleStatus: Types.ApiFixedPriceStatus } | { __typename: 'HighlightFixedPriceSaleConfiguration', highlightId: string, mintPrice: number, startTime: string, optionalEndTime: string | null, optionalMaxTokenId: number | null, vectorId: number, highlightFixedPriceSaleStatus: Types.ApiHighlightFixedPriceStatus } | { __typename: 'HighlightLinearDutchAuctionSaleConfiguration' } | { __typename: 'HighlightStaggeredDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, highlightId: string, mintVectorId: string, maxPrice: number, maxTokenId: number, minPrice: number, mintEndTime: string | null, startTime: string, highlightStaggeredDutchAuctionStatus: Types.ApiHighlightDutchAuctionStatus, prices: Array<{ endTime: string, price: number }> } | { __typename: 'LinearDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, maxPrice: number, maxTokenId: number, minPrice: number, startTime: string, fndLinearDutchAuctionStatus: Types.ApiDutchAuctionStatus } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null } | { __typename: 'EditionCollection', chainId: ChainId, contractAddress: Address, nftCount: number, slug: string, contractType: Types.ApiContractType, assetUrl: string | null, mimeType: string | null, editionName: string, editionId: string, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, editionSale: { __typename: 'LimitedEditionSaleConfiguration', maxTokenId: number, mintPrice: number, startTime: string, limitedEditionStatus: Types.ApiLimitedEditionStatus } | { __typename: 'TimedEditionSaleConfiguration', endTime: string, mintPrice: number, startTime: string, timedEditionStatus: Types.ApiTimedEditionStatus } } | { __typename: 'MarketNft', chainId: ChainId, name: string | null, id: string, tokenId: number, contractAddress: Address, saleStartsAt: string | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, activeAuction: { duration: number, id: number, reservePrice: number, state: Types.ApiAuctionState, expiryDate: string | null, highestBid: { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null } | null, activeBuyNow: { amount: number } | null, activeOffer: { amount: number, expiryDate: string } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null } | { __typename: 'SoldNft', chainId: ChainId, contractAddress: Address, tokenId: number, soldNftId: string, soldNftName: string | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, sale: { amount: number, date: string } } } | { __typename: 'StoryItemJsonContent', ast: object } };

export type ApiStoryGroupFragment = { id: string, size: Types.ApiStoryGroupSize, items: Array<{ id: string, type: Types.ApiStoryGroupItemType, contentV2: { __typename: 'StoryItemInventoryContent', referenceId: string, item: { __typename: 'DropCollection', chainId: ChainId, contractAddress: Address, slug: string, nftCount: number, dropName: string, dropId: string, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, saleConfiguration: { __typename: 'FixedPriceSaleConfiguration', maxTokenId: number, mintPrice: number, presaleStartTime: string | null, startTime: string, fndFixedPriceSaleStatus: Types.ApiFixedPriceStatus } | { __typename: 'HighlightFixedPriceSaleConfiguration', highlightId: string, mintPrice: number, startTime: string, optionalEndTime: string | null, optionalMaxTokenId: number | null, vectorId: number, highlightFixedPriceSaleStatus: Types.ApiHighlightFixedPriceStatus } | { __typename: 'HighlightLinearDutchAuctionSaleConfiguration' } | { __typename: 'HighlightStaggeredDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, highlightId: string, mintVectorId: string, maxPrice: number, maxTokenId: number, minPrice: number, mintEndTime: string | null, startTime: string, highlightStaggeredDutchAuctionStatus: Types.ApiHighlightDutchAuctionStatus, prices: Array<{ endTime: string, price: number }> } | { __typename: 'LinearDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, maxPrice: number, maxTokenId: number, minPrice: number, startTime: string, fndLinearDutchAuctionStatus: Types.ApiDutchAuctionStatus } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null } | { __typename: 'EditionCollection', chainId: ChainId, contractAddress: Address, nftCount: number, slug: string, contractType: Types.ApiContractType, assetUrl: string | null, mimeType: string | null, editionName: string, editionId: string, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, editionSale: { __typename: 'LimitedEditionSaleConfiguration', maxTokenId: number, mintPrice: number, startTime: string, limitedEditionStatus: Types.ApiLimitedEditionStatus } | { __typename: 'TimedEditionSaleConfiguration', endTime: string, mintPrice: number, startTime: string, timedEditionStatus: Types.ApiTimedEditionStatus } } | { __typename: 'MarketNft', chainId: ChainId, name: string | null, id: string, tokenId: number, contractAddress: Address, saleStartsAt: string | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, activeAuction: { duration: number, id: number, reservePrice: number, state: Types.ApiAuctionState, expiryDate: string | null, highestBid: { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null } | null, activeBuyNow: { amount: number } | null, activeOffer: { amount: number, expiryDate: string } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null } | { __typename: 'SoldNft', chainId: ChainId, contractAddress: Address, tokenId: number, soldNftId: string, soldNftName: string | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, sale: { amount: number, date: string } } } | { __typename: 'StoryItemJsonContent', ast: object } }> };

export type ApiStoryFragment = { hiddenAt: string | null, groups: Array<{ id: string, size: Types.ApiStoryGroupSize, items: Array<{ id: string, type: Types.ApiStoryGroupItemType, contentV2: { __typename: 'StoryItemInventoryContent', referenceId: string, item: { __typename: 'DropCollection', chainId: ChainId, contractAddress: Address, slug: string, nftCount: number, dropName: string, dropId: string, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, saleConfiguration: { __typename: 'FixedPriceSaleConfiguration', maxTokenId: number, mintPrice: number, presaleStartTime: string | null, startTime: string, fndFixedPriceSaleStatus: Types.ApiFixedPriceStatus } | { __typename: 'HighlightFixedPriceSaleConfiguration', highlightId: string, mintPrice: number, startTime: string, optionalEndTime: string | null, optionalMaxTokenId: number | null, vectorId: number, highlightFixedPriceSaleStatus: Types.ApiHighlightFixedPriceStatus } | { __typename: 'HighlightLinearDutchAuctionSaleConfiguration' } | { __typename: 'HighlightStaggeredDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, highlightId: string, mintVectorId: string, maxPrice: number, maxTokenId: number, minPrice: number, mintEndTime: string | null, startTime: string, highlightStaggeredDutchAuctionStatus: Types.ApiHighlightDutchAuctionStatus, prices: Array<{ endTime: string, price: number }> } | { __typename: 'LinearDutchAuctionSaleConfiguration', clearingPrice: number | null, endTime: string, maxPrice: number, maxTokenId: number, minPrice: number, startTime: string, fndLinearDutchAuctionStatus: Types.ApiDutchAuctionStatus } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null } | { __typename: 'EditionCollection', chainId: ChainId, contractAddress: Address, nftCount: number, slug: string, contractType: Types.ApiContractType, assetUrl: string | null, mimeType: string | null, editionName: string, editionId: string, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, editionSale: { __typename: 'LimitedEditionSaleConfiguration', maxTokenId: number, mintPrice: number, startTime: string, limitedEditionStatus: Types.ApiLimitedEditionStatus } | { __typename: 'TimedEditionSaleConfiguration', endTime: string, mintPrice: number, startTime: string, timedEditionStatus: Types.ApiTimedEditionStatus } } | { __typename: 'MarketNft', chainId: ChainId, name: string | null, id: string, tokenId: number, contractAddress: Address, saleStartsAt: string | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, activeAuction: { duration: number, id: number, reservePrice: number, state: Types.ApiAuctionState, expiryDate: string | null, highestBid: { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null } | null, activeBuyNow: { amount: number } | null, activeOffer: { amount: number, expiryDate: string } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null } | { __typename: 'SoldNft', chainId: ChainId, contractAddress: Address, tokenId: number, soldNftId: string, soldNftName: string | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null, sale: { amount: number, date: string } } } | { __typename: 'StoryItemJsonContent', ast: object } }> }> };

export type ApiBookmarkFragment = { id: string, publicKey: string, createdAt: string, content: { id: number, name: string, description: string | null, worldId: number, posterUrl: string, startsAt: string, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, world: { chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } } };

export type ApiListableNftFragment = { assetUrl: string | null, name: string | null, contractAddress: Address, tokenId: number, id: string };

export type ApiAuctionFragment = { duration: number, expiryDate: string | null, id: number, reservePrice: number, state: Types.ApiAuctionState, highestBid: { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null };

export type ApiSaleFragment = { amount: number, date: string, type: Types.ApiSaleType, worldId: number | null, buyer: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } };

export type ApiSplitFragment = { sharePercent: number, user: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } };

export type ApiTokenFragment_Erc1155Token_ = { __typename: 'ERC1155Token', chainId: ChainId, contractAddress: Address, tokenId: number };

export type ApiTokenFragment_MarketNft_ = { __typename: 'MarketNft', id: string, name: string | null, description: string | null, saleStartsAt: string | null, metadataUrl: string | null, sourceUrl: string | null, moderationFrom: string | null, moderationStatus: Types.ApiModerationStatus, chainId: ChainId, contractAddress: Address, tokenId: number, activeAuction: { duration: number, expiryDate: string | null, id: number, reservePrice: number, state: Types.ApiAuctionState, highestBid: { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null } | null, activeBuyNow: { amount: number } | null, activeOffer: { amount: number, expiryDate: string } | null, collection: { chainId: ChainId, collectionImageUrl: string | null, contractAddress: Address, contractType: Types.ApiContractType, coverImageUrl: string | null, moderationFrom: string | null, moderationStatus: Types.ApiModerationStatus, name: string, slug: string, symbol: string }, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, owner: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } | null, lastSale: { amount: number, date: string, type: Types.ApiSaleType, worldId: number | null, buyer: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null };

export type ApiTokenFragment = ApiTokenFragment_Erc1155Token_ | ApiTokenFragment_MarketNft_;

export type ApiEditionTokenHolderFragment = { count: number, user: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } };

export type ApiMarketCollectionFragment = { chainId: number, collectionImageUrl: string | null, contractAddress: string, contractType: Types.ApiContractType, coverImageUrl: string | null, createdAt: string, deletedAt: string | null, description: string | null, hiddenAt: string | null, id: string, isIndexed: boolean, isRevealed: boolean, moderationStatus: Types.ApiModerationStatus, name: string, slug: string, symbol: string | null, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } };


export const UserMicroFragment = /*#__PURE__*/ `
    fragment UserMicroFragment on User {
  profileImageUrl
  publicKey: accountAddress
  username
}
    `;
export const UserLightFragment = /*#__PURE__*/ `
    fragment UserLightFragment on UserLightInterface {
  name
  profileImageUrl
  publicKey: accountAddress
  username
}
    `;
export const BidFragment = /*#__PURE__*/ `
    fragment BidFragment on Bid {
  amount
  bidder {
    ...UserLightFragment
  }
}
    `;
export const CollectionLightFragment = /*#__PURE__*/ `
    fragment CollectionLightFragment on CollectionInterface {
  name
  slug
  chainId
  collectionImageUrl
  contractAddress
  contractType
}
    `;
export const MediaFragment = /*#__PURE__*/ `
    fragment MediaFragment on Media {
  __typename
  ... on ImageMedia {
    processingStatus
    sourceUrl
    url
    imageMimeType: mimeType
  }
  ... on VideoMedia {
    previewUrl
    processingStatus
    sourceUrl
    staticUrl
    url
    videoMimeType: mimeType
  }
  ... on ModelMedia {
    processingStatus
    sourceUrl
    url
    modelMimeType: mimeType
    modelStaticUrl: staticUrl
  }
}
    `;
export const DropSaleConfigurationFragment = /*#__PURE__*/ `
    fragment DropSaleConfigurationFragment on DropSaleConfiguration {
  __typename
  ... on LinearDutchAuctionSaleConfiguration {
    clearingPrice
    endTime
    maxPrice
    maxTokenId
    minPrice
    startTime
    fndLinearDutchAuctionStatus: status
  }
  ... on FixedPriceSaleConfiguration {
    maxTokenId
    mintPrice
    presaleStartTime
    startTime
    fndFixedPriceSaleStatus: status
  }
  ... on HighlightStaggeredDutchAuctionSaleConfiguration {
    clearingPrice
    endTime
    highlightId
    mintVectorId
    maxPrice
    maxTokenId
    minPrice
    mintEndTime
    startTime
    highlightStaggeredDutchAuctionStatus: status
    prices {
      endTime
      price
    }
  }
  ... on HighlightFixedPriceSaleConfiguration {
    optionalEndTime: endTime
    highlightId
    optionalMaxTokenId: maxTokenId
    vectorId: mintVectorId
    mintPrice
    startTime
    highlightFixedPriceSaleStatus: status
  }
}
    `;
export const DropFragment = /*#__PURE__*/ `
    fragment DropFragment on DropCollection {
  brandColor
  chainId
  clearingPrice
  collectionImageUrl
  contractAddress
  contractType
  coverImageUrl
  creator {
    ...UserLightFragment
  }
  description
  earlyAccessStartTime
  endTime
  generalAvailabilityStartTime
  id
  isRevealed
  lastMintedAt
  media {
    ...MediaFragment
  }
  minPrice
  mintPrice
  moderationFrom
  moderationStatus
  name
  nftCount
  saleConfiguration {
    ...DropSaleConfigurationFragment
  }
  saleType
  slug
  status: availabilityStatus
  symbol
  worldId
}
    `;
export const DropSpotlightFragment = /*#__PURE__*/ `
    fragment DropSpotlightFragment on DropCollection {
  ...DropFragment
  totalSales: totalVolumeInEth
}
    `;
export const HomeTabFragment = /*#__PURE__*/ `
    fragment HomeTabFragment on NftGroup {
  items {
    createdAt
    nftId
    id
    position
    size
  }
}
    `;
export const ArtworkFragment = /*#__PURE__*/ `
    fragment ArtworkFragment on Artwork {
  id
  name
  description
  assetScheme
  assetHost
  assetPath
  assetIPFSPath
  metadataScheme
  metadataHost
  metadataPath
  metadataIPFSPath
  mintTxHash
  auctionStartTxHash
  width
  height
  duration
  mimeType
  tokenId
  status
  hiddenAt
  deletedAt
  moderationStatus
}
    `;
export const ArtworkFragmentPrivate = /*#__PURE__*/ `
    fragment ArtworkFragmentPrivate on Artwork {
  ...ArtworkFragment
  downloadableUrl
}
    `;
export const CollectionFragment = /*#__PURE__*/ `
    fragment CollectionFragment on LegacyCollection {
  id
  contractAddress
  symbol
  name
  slug
  description
  collectionImageUrl
  coverImageUrl
  createdAt
  updatedAt
}
    `;
export const WorldOverviewOnExhibition = /*#__PURE__*/ `
    fragment WorldOverviewOnExhibition on Exhibition {
  chainId
  id
  name
  slug
  moderationStatus
  imageUrl
  coverUrl
  takeRateInBasisPoints
  curator {
    ...UserLightFragment
  }
}
    `;
export const WorldOverviewFragment = /*#__PURE__*/ `
    fragment WorldOverviewFragment on World {
  chainId
  id
  name
  slug
  moderationStatus
  imageUrl
  coverUrl
  takeRateInBasisPoints
  curator {
    ...UserLightFragment
  }
}
    `;
export const WorldFragment = /*#__PURE__*/ `
    fragment WorldFragment on World {
  ...WorldOverviewFragment
  curatorAddress
  description
  moderationFrom
}
    `;
export const MomentSearchItemFragment = /*#__PURE__*/ `
    fragment MomentSearchItemFragment on MomentSearchItem {
  id
  name
  posterUrl
  worldId
  worldImageUrl
  worldName
  worldSlug
}
    `;
export const WorldInventoryDrop = /*#__PURE__*/ `
    fragment WorldInventoryDrop on InventoryDropCollection {
  clearingPrice
  contractAddress
  curatorRevenue
  description
  earlyAccessStartTime
  generalAvailabilityStartTime
  id
  isFeatured
  mintPrice
  name
  nftCount
  saleType
  slug
  totalPageViews
  totalVolumeInEth
  chainId
  creator {
    ...UserLightFragment
  }
  media {
    ...MediaFragment
  }
  saleConfiguration {
    ...DropSaleConfigurationFragment
  }
}
    `;
export const EditionSaleConfigurationFragment = /*#__PURE__*/ `
    fragment EditionSaleConfigurationFragment on EditionSaleConfiguration {
  __typename
  ... on TimedEditionSaleConfiguration {
    endTime
    mintPrice
    startTime
    timedEditionStatus: status
  }
  ... on LimitedEditionSaleConfiguration {
    maxTokenId
    mintPrice
    startTime
    limitedEditionStatus: status
  }
}
    `;
export const WorldInventoryEdition = /*#__PURE__*/ `
    fragment WorldInventoryEdition on InventoryEditionCollection {
  contractAddress
  contractType
  curatorRevenue
  description
  id
  isFeatured
  name
  nftCount
  slug
  totalPageViews
  totalVolumeInEth
  chainId
  creator {
    ...UserLightFragment
  }
  media {
    ...MediaFragment
  }
  editionSale: saleConfiguration {
    ...EditionSaleConfigurationFragment
  }
}
    `;
export const WorldInventoryMarketNft = /*#__PURE__*/ `
    fragment WorldInventoryMarketNft on InventoryMarketNft {
  chainId
  contractAddress
  id
  isFeatured
  name
  saleStartsAt
  tokenId
  totalPageViews
  activeAuction {
    expiryDate
    highestBid {
      amount
      bidder {
        ...UserLightFragment
      }
    }
    reservePrice
    state
  }
  activeBuyNow {
    amount
  }
  activeOffer {
    amount
    expiryDate
  }
  creator {
    ...UserLightFragment
  }
  media {
    ...MediaFragment
  }
}
    `;
export const WorldInsightBreakdownStats = /*#__PURE__*/ `
    fragment WorldInsightBreakdownStats on ExhibitionInventoryTimespanStat {
  timestamp
  totalPageViews
  totalSales
}
    `;
export const MomentStatsFragment = /*#__PURE__*/ `
    fragment MomentStatsFragment on MomentStatsV2 {
  collectorsCount
  liveActivityCount
  totalSales
  worksCount
  isSoldOut
  bookmarksCount
}
    `;
export const EditionFragment = /*#__PURE__*/ `
    fragment EditionFragment on EditionCollection {
  chainId
  id
  name
  slug
  symbol
  nftCount
  description
  contractAddress
  assetUrl
  mimeType
  moderationStatus
  moderationFrom
  tokenUri
  contractType
  worldId
  creator {
    ...UserLightFragment
  }
  editionSale: saleConfiguration {
    ...EditionSaleConfigurationFragment
  }
}
    `;
export const EditionSpotlightFragment = /*#__PURE__*/ `
    fragment EditionSpotlightFragment on EditionCollection {
  ...EditionFragment
  totalSales: totalVolumeInEth
}
    `;
export const NftSpotlightFragment = /*#__PURE__*/ `
    fragment NftSpotlightFragment on MarketNft {
  chainId
  name
  tokenId
  description
  contractAddress
  activeBuyNow {
    amount
  }
  activeOffer {
    expiryDate
    publicKey: accountAddress
    amount
  }
  activeAuction {
    id
    state
    expiryDate
    reservePrice
    duration
    highestBid {
      amount
      bidder {
        ...UserLightFragment
      }
    }
  }
  saleStartsAt
  lastSale {
    amount
    date
    worldId
    buyer {
      ...UserLightFragment
    }
  }
  media {
    ...MediaFragment
  }
  creator {
    ...UserLightFragment
  }
  world {
    ...WorldOverviewFragment
  }
}
    `;
export const MarketNftGridFields = /*#__PURE__*/ `
    fragment MarketNftGridFields on MarketNft {
  chainId
  name
  id
  tokenId
  contractAddress
  creator {
    ...UserLightFragment
  }
  saleStartsAt
  activeAuction {
    duration
    id
    reservePrice
    state
    highestBid {
      amount
      bidder {
        ...UserLightFragment
      }
    }
    expiryDate
  }
  activeBuyNow {
    amount
  }
  activeOffer {
    amount
    expiryDate
  }
  media {
    ...MediaFragment
  }
}
    `;
export const StoryInventoryItemFragment = /*#__PURE__*/ `
    fragment StoryInventoryItemFragment on MomentInventoryItem {
  __typename
  ... on MarketNft {
    ...MarketNftGridFields
  }
  ... on SoldNft {
    chainId
    soldNftId: id
    soldNftName: name
    contractAddress
    creator {
      ...UserLightFragment
    }
    media {
      ...MediaFragment
    }
    sale {
      amount
      date
    }
    tokenId
  }
  ... on EditionCollection {
    chainId
    contractAddress
    nftCount
    editionName: name
    editionId: id
    creator {
      ...UserLightFragment
    }
    slug
    contractType
    assetUrl
    mimeType
    media {
      ...MediaFragment
    }
    editionSale: saleConfiguration {
      ...EditionSaleConfigurationFragment
    }
  }
  ... on DropCollection {
    chainId
    contractAddress
    creator {
      ...UserLightFragment
    }
    dropName: name
    dropId: id
    slug
    saleConfiguration {
      ...DropSaleConfigurationFragment
    }
    media {
      ...MediaFragment
    }
    nftCount
  }
}
    `;
export const StoryItemFragment = /*#__PURE__*/ `
    fragment StoryItemFragment on StoryGroupItem {
  id
  type
  contentV2 {
    __typename
    ... on StoryItemJsonContent {
      ast
    }
    ... on StoryItemInventoryContent {
      referenceId
      item {
        ...StoryInventoryItemFragment
      }
    }
  }
}
    `;
export const StoryGroupFragment = /*#__PURE__*/ `
    fragment StoryGroupFragment on StoryGroup {
  id
  size
  items {
    ...StoryItemFragment
  }
}
    `;
export const StoryFragment = /*#__PURE__*/ `
    fragment StoryFragment on Story {
  hiddenAt
  groups {
    ...StoryGroupFragment
  }
}
    `;
export const MomentFragment = /*#__PURE__*/ `
    fragment MomentFragment on Moment {
  id
  name
  description
  worldId
  posterUrl
  startsAt
  takeRateInBasisPoints
}
    `;
export const MomentOverviewFragment = /*#__PURE__*/ `
    fragment MomentOverviewFragment on Moment {
  ...MomentFragment
  curator {
    ...UserLightFragment
  }
  world {
    ...WorldOverviewFragment
  }
}
    `;
export const BookmarkFragment = /*#__PURE__*/ `
    fragment BookmarkFragment on Bookmark {
  id
  publicKey
  createdAt
  content {
    ...MomentOverviewFragment
  }
}
    `;
export const ListableNftFragment = /*#__PURE__*/ `
    fragment ListableNftFragment on NftAsset {
  assetUrl
  name
  contractAddress
  tokenId
  id
}
    `;
export const SplitFragment = /*#__PURE__*/ `
    fragment SplitFragment on UserSplit {
  sharePercent
  user {
    ...UserLightFragment
  }
}
    `;
export const NftIdentifiersFragment = /*#__PURE__*/ `
    fragment NftIdentifiersFragment on NftInterface {
  chainId
  contractAddress
  tokenId
}
    `;
export const AuctionFragment = /*#__PURE__*/ `
    fragment AuctionFragment on Auction {
  duration
  expiryDate
  highestBid {
    amount
    bidder {
      ...UserLightFragment
    }
  }
  id
  reservePrice
  state
}
    `;
export const SaleFragment = /*#__PURE__*/ `
    fragment SaleFragment on Sale {
  amount
  buyer {
    ...UserLightFragment
  }
  date
  type
  worldId
}
    `;
export const TokenFragment = /*#__PURE__*/ `
    fragment TokenFragment on Token {
  __typename
  ... on ERC1155Token {
    ...NftIdentifiersFragment
  }
  ... on MarketNft {
    ...NftIdentifiersFragment
    id
    name
    description
    saleStartsAt
    metadataUrl
    sourceUrl
    moderationFrom
    moderationStatus
    activeAuction {
      ...AuctionFragment
    }
    activeBuyNow {
      amount
    }
    activeOffer {
      amount
      expiryDate
    }
    collection {
      chainId
      collectionImageUrl
      contractAddress
      contractType
      coverImageUrl
      moderationFrom
      moderationStatus
      name
      slug
      symbol
    }
    creator {
      ...UserLightFragment
    }
    owner {
      ...UserLightFragment
    }
    lastSale {
      ...SaleFragment
    }
    media {
      ...MediaFragment
    }
  }
}
    `;
export const EditionTokenHolderFragment = /*#__PURE__*/ `
    fragment EditionTokenHolderFragment on TokenHolderBalance {
  count: tokenCount
  user {
    ...UserLightFragment
  }
}
    `;
export const MarketCollectionFragment = /*#__PURE__*/ `
    fragment MarketCollectionFragment on MarketCollection {
  chainId
  collectionImageUrl
  contractAddress
  contractType
  coverImageUrl
  createdAt
  creator {
    ...UserLightFragment
  }
  deletedAt
  description
  hiddenAt
  id
  isIndexed
  isRevealed
  moderationStatus
  name
  slug
  symbol
}
    `;